import { clients } from "./clients";
import { eventReports } from "./event-reports";
import { HAWKERS_REPORT_ES_ES } from "#pages/event/hawkers-report/translations";

export const event = {
	hawkersReport: HAWKERS_REPORT_ES_ES,
	clients,
	...eventReports,
};
